export const withUnit = (value: string | number, unit: string): string => {
  return `${value} ${unit}`;
};
